export enum traceabilitiesTypes {
  GET_FILTER_LIST = '@@traceabilities/GET_FILTER_LIST',
  GET_FILTERS = '@@traceabilities/GET_FILTERS ',
  GET_FILTERS_SUCCESS = '@@traceabilities/GET_FILTERS_SUCCESS ',
  GET_FILTER_LIST_SUCCESS = '@@traceabilities/GET_FILTER_LIST_SUCCESS',
  GET_FILTER_LIST_ERROR = '@@traceabilities/GET_FILTER_LIST_ERROR',
  GET_FILTER_LIST_WRNUMBER = '@@traceabilities/GET_FILTER_LIST_WRNUMBER',
  GET_FILTER_LIST_SUCCESS_WRNUMBER = '@@traceabilities/GET_FILTER_LIST_SUCCESS_WRNUMBER',
  GET_FILTER_LIST_FAIL_WRNUMBER = '@@traceabilities/GET_FILTER_LIST_FAIL_WRNUMBER',
}
